// Importing 3rd party dependencies
import moment from 'moment';
// ----------------------------------------------------------------------
export const useDuration = () => {
    // Helper function to calculate progress change
    const calculateProgress = (direction = 'backwards', duration, played) => {
        const ratio = 10 / duration;
        const progress = direction === 'backwards' ? played - ratio : played + ratio;
        return progress > 0 ? progress : 0;
    };
    // Helper function to convert position into progress
    const convertPosition = (duration, position) => {
        const progress = Math.ceil((duration * position) / 10);
        // Without progress, no thumbnail
        // Therefore, we return the first thumbnail
        if (progress < 0) {
            return 1;
        }
        // If the progress is greater than 95%, we return the last thumbnail
        // We do this to avoid displaying a blank thumbnail
        if (position > 0.95) {
            return progress - 1;
        }
        return progress;
    };
    // Helper function to format duration in seconds
    const formatDuration = (duration) => {
        const milliseconds = duration * 1000;
        const convertedDuration = moment.duration(milliseconds);
        return moment.utc(milliseconds).format(convertedDuration.hours() > 0 ? 'HH:mm:ss' : 'mm:ss');
    };
    // Returning all hook options
    return { calculateProgress, convertPosition, formatDuration };
};
